/**
 * CARD_V9 타임라인 네이비 — 연도+짧은 라벨(편집·저장·표시 공통).
 */

const MAX_LABEL = 40

export function defaultCardV9TimelineYears() {
  const nowY = new Date().getFullYear()
  return [nowY - 18, nowY - 12, nowY - 6, nowY - 2, nowY]
}

/** 5칸 편집용 기본 슬롯 { year, label } (문자열 year는 입력란용) */
export function defaultCardV9TimelineSlots() {
  return defaultCardV9TimelineYears().map((y) => ({ year: String(y), label: '' }))
}

function clampLabel(s) {
  const t = String(s ?? '').trim()
  return t.length > MAX_LABEL ? t.slice(0, MAX_LABEL) : t
}

/** API → 5칸 슬롯. cardTimeline 우선, 없으면 cardTimelineYears(레거시). */
export function hydrateCardTimelineSlots(apiRow) {
  const tl = apiRow?.cardTimeline
  if (Array.isArray(tl) && tl.length >= 2) {
    const slots = []
    for (const row of tl) {
      if (!row || typeof row !== 'object') continue
      const y = Number(row.year)
      if (!Number.isFinite(y) || y < 1900 || y > 2100) continue
      slots.push({ year: String(y), label: clampLabel(row.label) })
    }
    if (slots.length >= 2) {
      while (slots.length < 5) slots.push({ year: '', label: '' })
      return slots.slice(0, 5)
    }
  }
  const raw = apiRow?.cardTimelineYears
  if (Array.isArray(raw) && raw.length >= 2) {
    const slots = raw
      .map((y) => Number(y))
      .filter((n) => Number.isFinite(n) && n >= 1900 && n <= 2100)
      .slice(0, 8)
      .map((y) => ({ year: String(y), label: '' }))
    while (slots.length < 5) slots.push({ year: '', label: '' })
    return slots.slice(0, 5)
  }
  return defaultCardV9TimelineSlots()
}

/** 5칸 입력 → 저장용 [{ year, label }, ...] (순서 유지, 2~8개 유효 연도). */
export function parseCardTimelineSlotsForSave(slots) {
  const list = Array.isArray(slots) ? slots : []
  const out = []
  for (const s of list) {
    if (!s || typeof s !== 'object') continue
    const t = String(s.year ?? '').trim()
    if (!t) continue
    const n = parseInt(t, 10)
    if (!Number.isFinite(n) || n < 1900 || n > 2100) continue
    out.push({ year: n, label: clampLabel(s.label) })
  }
  return out.length >= 2 ? out.slice(0, 8) : []
}

/** 공개 명함 표시용: API cardTimeline 또는 레거시 연도만 */
export function normalizeCardTimelineItems(apiRow) {
  const tl = apiRow?.cardTimeline
  if (Array.isArray(tl) && tl.length >= 2) {
    const items = []
    for (const row of tl) {
      if (!row || typeof row !== 'object') continue
      const y = Number(row.year)
      if (!Number.isFinite(y) || y < 1900 || y > 2100) continue
      items.push({ year: y, label: clampLabel(row.label) })
    }
    if (items.length >= 2) return items
  }
  const raw = apiRow?.cardTimelineYears
  if (Array.isArray(raw) && raw.length >= 2) {
    const ys = raw
      .map((y) => Number(y))
      .filter((n) => Number.isFinite(n) && n >= 1900 && n <= 2100)
    if (ys.length >= 2) return ys.map((year) => ({ year, label: '' }))
  }
  return null
}
